import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_eradtetzzl: FaireBrandEntity = {
  token: "b_eradtetzzl",
  type: "brand",
  name: "Healthy Energy Amazing Life",
  avatarUrl:
    "https://cdn.faire.com/fastly/81cc19ee4a56b341dafc70f6c6b4a0f5eb914ecc4a1fc398439061011d7c30a8.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/06501b59db8fc3d4e00dbb77b803e358d97bf415c44faccf9dc5bb10717dab0b.png",
  logoUrl:
    "https://cdn.faire.com/fastly/81cc19ee4a56b341dafc70f6c6b4a0f5eb914ecc4a1fc398439061011d7c30a8.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/06501b59db8fc3d4e00dbb77b803e358d97bf415c44faccf9dc5bb10717dab0b.png",
  location: "Carrollton, GA, USA",
  minimumOrderDollars: 25,
  rating: 4.9,
  reviewCount: 101,
  isTopShop: true,
  isInsider: true,
  description:
    "Since 1991, H.E.A.L. has been dedicated to supporting wellness—naturally. Founded by Dr. Harmony, whose passion led her to earn both a Master’s and Doctorate in Natural Health, H.E.A.L. stands as one of the original pioneers in the natural health movement.\n\nRooted in trust and tradition, our handcrafted products—including Harmony’s Ear Candles, Mullein Oil, and Plantain Cream—are made in small batches in rural Georgia. We proudly collaborate with single mothers, individuals with disabilities, and homeschooling families to keep our process people-powered and purpose-driven.\n\nH.E.A.L. is also the exclusive U.S. partner of ŐSIMAGNESIUM, offering premium magnesium butters, gels, lotions, and flakes sourced directly from the ancient Zechstein seabed. We also carry BodyTox Foot Patches and a wide selection of pure essential oils—many sourced directly from growers—with custom blends available by request.\n\nAt H.E.A.L., we honor simplicity, integrity, and the healing power of nature.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:46.772Z",
    importedBy: "entity-db-cli",
  },
};
